import React, { useEffect, useState } from 'react';
import { Modal, Heading, Row, Col, ButtonAction, Table } from 'components';
import { Margin } from 'styled-components-spacing';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setSeenCpdSumsCreator } from '../../../store/actionsCreators';

const CPDWarning = ({ markCpdWarningsSeen, cpdSums }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const blurOverlay = (show) => {
    document.body.classList[show ? 'add' : 'remove']('content-blur');
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleAcknowledge = () => {
    if (cpdSums.length > 0) {
      markCpdWarningsSeen({ ids: cpdSums.map((sum) => sum.id) });
    }
    handleClose();
  };

  useEffect(() => {
    if (modalOpen) {
      blurOverlay(true);
    }
    return () => blurOverlay(false);
  }, [modalOpen]);

  useEffect(() => {
    const insufficientCpd = cpdSums.some(
      (sum) => (sum.year && sum.sumPoints < 35) || (sum.certificate && sum.sumPoints < 175),
    );
    setModalOpen(insufficientCpd);
  }, [cpdSums]);

  const renderContent = () => (
    <Margin bottom="3" top="3">
      <Row halign="center">
        <Col>{t('global.cpdWarningDescription')}</Col>
      </Row>
      <Margin top="3">
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.Heading>{t('global.certificateOrYear', 'Certificate / Year')}</Table.Heading>
              <Table.Heading>{t('global.cpdPoints', 'CPD Points')}</Table.Heading>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {cpdSums
              .filter(
                (sum) =>
                  (sum.year && sum.sumPoints < 35) || (sum.certificate && sum.sumPoints < 175),
              )
              .map((sum) => (
                <Table.Row key={sum.id} halign="center">
                  <Table.Cell>
                    {sum.certificate && (
                      <span>{`${sum.certificate.certificateId} ${
                        sum.certificate.levelDomain ? `[${sum.certificate.levelDomain}]` : ''
                      }`}</span>
                    )}
                    {sum.year && <span>{`${t('global.year')} - ${sum.year}`}</span>}
                  </Table.Cell>
                  <Table.Cell>
                    <span>{`${sum.sumPoints} CPD Points`}</span>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Margin>
    </Margin>
  );

  return (
    <Modal
      isOpen={modalOpen}
      heading={t('global.cpdWarningTitle', 'Insufficient CPD Points')}
      description={renderContent()}
      customActions={(Action) => (
        <Row>
          <Margin as={Col} bottom={{ xs: 16, md: 0 }} size={{ md: 1 / 2 }}>
            <Action icon="check" onClick={handleAcknowledge}>
              {t('global.acknowledge', 'Acknowledge')}
            </Action>
          </Margin>
          <Col size={{ md: 1 / 2 }}>
            <Action icon="close" bordered onClick={handleClose}>
              {t('global.close', 'Close')}
            </Action>
          </Col>
        </Row>
      )}
      onRequestClose={handleClose}
    />
  );
};

CPDWarning.defaultProps = {
  cpdSums: [],
};

const mapStateToProps = ({ cpd }) => ({
  cpdSums: cpd.userCpd.sums,
});

const mapDispatchToProps = (dispatch) => ({
  markCpdWarningsSeen: (payload) => dispatch(setSeenCpdSumsCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CPDWarning);
